import {mapState} from "vuex";

export default {
  computed: {
    ...mapState("user", ["auth"]),
    ...mapState("clients", ["generalQueryObject"])
  },
  methods: {
    checkIfTotalMode() {
      let res = false;
      if (this.generalQueryObject.hasOwnProperty("online")) {
        res = true;
      }
      return res;
    }
  }
};
